import React from 'react';
import Wrapper from '../../ui/Wrapper';
import Text from '../../ui/Text';
import OddsButton from '../../ui/Button';
import { APP_PATH, goToWithBasePath } from '../../constants/appConfig';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    clearAllCustomBetMarkets as ClearAllCustomBetMarkets,
    addCustomBetRecommendation as AddCustomBetRecommendation,
    clearAllMarkets as ClearAllMarkets,
} from '../../actions/BetslipActions';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import { detectMobile, formatDate } from '../../utils/UiHelper';
import { showModal as ShowModal } from '../../actions/UiActions';
import { trackEvents } from '../../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATIONS,
    VAIX_TRACKING_TYPE,
} from '../../constants/vaix/VaixTrcakingConstants';
import { SkeletonButton } from '../../components/SkeletonUI/styled';
import { SkeletonAnimation } from '../../components/SkeletonUI/skeletonAnimation';
import { DotForTextAtBeginning, ThreeDots } from '../../styled';

const CustomBetRecommendationItem = ({
    betRecommendation,
    eventName,
    isEventPage = false,
    vaixEventId,
    vaixExternalEventId,
    betslip,
    clearAllCustomBetMarkets,
    addCustomBetRecommendation,
    concatedEvents,
    showModal,
    clearAllMarkets,
    group,
    competition,
    userId,
    position,
    selections,
    kickoff,
    isOddsFetched = false,
}) => {
    const getIcon = (id) => {
        return (
            <img
                src={`${APP_PATH}/img/sports/${id}.png`}
                alt=""
                className={'cb-rec-item-content__sport-icon'}
            />
        );
    };

    const getEventsList = (items) => {
        return (
            <ul className={`events-list ${isEventPage && 'event-page'}`}>
                {items.map((item, index) => {
                    return (
                        <li key={index}>
                            <ThreeDots maxWidth={'calc(50% - 5px)'}>
                                {item.market.marketName}
                            </ThreeDots>{' '}
                            <DotForTextAtBeginning color={'#1E1E1E'} />
                            <ThreeDots maxWidth={'calc(50% - 5px)'}>
                                <b>{item.outcome.competitor}</b>
                            </ThreeDots>
                        </li>
                    );
                })}
            </ul>
        );
    };

    const placeCustomBetRecommendation = () => {
        trackEvents(
            selections,
            VAIX_TRACKING_TYPE.clickCombinations,
            isEventPage
                ? VAIX_TRACKING_LOCATIONS.betBuilderEventPage
                : VAIX_TRACKING_LOCATIONS.betBuilderHomePage,
            isEventPage ? '/sport/kamp' : '/sport/',
            userId,
            1,
            position
        );

        addCustomBetRecommendation(vaixEventId, vaixExternalEventId);
    };
    const clearBetslip = () => {
        clearAllCustomBetMarkets();
    };

    const handleClick = () => {
        return isActive()
            ? clearBetslip()
            : betslip.setMarketsNew.length > 0
                ? handleError()
                : placeCustomBetRecommendation();
    };

    const isActive = () => {
        if (betslip.setMarketsNew.length === 0) {
            return false;
        } else {
            return areArraysEqual(concatedEvents, betslip.setMarketsNew);
        }
    };

    const areArraysEqual = (array1, array2) => {
        // Check if the arrays are the same length
        if (array1.length !== array2.length) {
            return false;
        }

        // Sort both arrays
        const sortedArray1 = [...array1].sort();
        const sortedArray2 = [...array2].sort();

        // Compare sorted arrays element by element
        for (let i = 0; i < sortedArray1.length; i++) {
            if (sortedArray1[i] !== sortedArray2[i]) {
                return false;
            }
        }

        // If all elements match, the arrays are equal
        return true;
    };

    const handleError = () => {
        if (betslip.customBetEventId === null) {
            if (detectMobile()) {
                let lsData = JSON.parse(
                    window.localStorage.getItem('clearRegularBetModalData')
                );

                if (lsData?.action === 'clearBetslip' && !lsData?.show) {
                    clearAllMarkets();

                    setTimeout(() => {
                        placeCustomBetRecommendation();
                    }, 1000);
                } else {
                    let betData = {
                        vaixEventId: vaixEventId,
                        vaixExternalEventId: vaixExternalEventId,
                    };
                    showModal('CLEAR_YOUR_COUPON', {
                        betData,
                    });
                }
            } else {
                NotificationManager.error(
                    <Text
                        fontSize={16}
                        margin={'0'}
                        padding={'0'}
                        bold
                        color={'#fff'}
                    >
                        Ryd din kupon først.
                        <br /> Byg væddemål kan ikke kombineres med andre spil.
                    </Text>
                );
            }
        } else {
            NotificationManager.error(
                <Text
                    fontSize={16}
                    margin={'0'}
                    padding={'0'}
                    bold
                    color={'#fff'}
                >
                    Kombinationen er ikke tilladt
                </Text>
            );
        }
    };

    const handleRedirectClick = (e) => {
        !isEventPage &&
            trackEvents(
                vaixEventId,
                VAIX_TRACKING_TYPE.clickEvent,
                isEventPage
                    ? VAIX_TRACKING_LOCATIONS.betBuilderEventPage
                    : VAIX_TRACKING_LOCATIONS.betBuilderHomePage,
                isEventPage ? '/sport/kamp' : '/sport/',
                userId,
                0,
                position,
                true
            );

        !isEventPage
            ? browserHistory.push(
                  goToWithBasePath(
                      `/kamp/${betRecommendation.items[0].market.eventId}`
                  )
              )
            : null;
    };

    return (
        <Wrapper
            flex
            height={'100%'}
            justify={isEventPage ? 'flex-start' : 'space-between'}
            flexDirection={isEventPage ? 'row' : 'column'}
            flexAlign={isEventPage ? 'flex-end' : 'flex-start'}
            boxSizing={'border-box'}
            padding={'0'}
            borderRadius={'8px'}
            border={'1px solid  #DFE5ED'}
            width={'100%'}
            minWidth={'240px'}
            className={`cb-rec-item-wrapper-inside ${
                isEventPage && !detectMobile() ? 'event-page' : ''
            }`}
            position={'relative'}
            overflow={'hidden'}
            zIndex={1}
            bgColor={'#fff'}
        >
            {!isEventPage &&
                getIcon(betRecommendation?.items[0]?.market.sportId || 1)}
            <Wrapper
                display={'block'}
                boxSizing={'border-box'}
                height={'100%'}
                width={'100%'}
                minWidth={'auto'}
                maxWidth={detectMobile() ? '320px' : 'inherit'}
                padding={
                    isEventPage && !detectMobile() ? '0' : '16px 16px 73px'
                }
                margin={'0'}
                className={`cb-rec-item-content ${
                    isEventPage && !detectMobile() ? 'event-page' : ''
                }`}
                onClick={handleRedirectClick}
                position={'relative'}
                zIndex={2}
            >
                {!isEventPage && (
                    <Wrapper
                        flex
                        flexDirection={'row'}
                        justify={'space-between'}
                        flexAlign={'flex-start'}
                        padding={'0'}
                        margin={'0'}
                        className={'cb-rec-item-content-top'}
                        boxSizing={'border-box'}
                    >
                        <div
                            className={`cb-rec-item-content__top-title ${isEventPage &&
                                'event-page'} `}
                        >
                            <div className={'bage-text three-dots'}>
                                <span>{`${competition}`}</span>
                            </div>
                            <Text
                                bold
                                size={detectMobile() ? '14' : '13'}
                                lh={detectMobile() ? '20' : '21'}
                                color={'#1E1E1E'}
                                margin={'8px 0 0!important'}
                                padding={'0'}
                                className={`cbrec-event-title ${
                                    isEventPage && !detectMobile()
                                        ? 'event-page'
                                        : ''
                                }`}
                            >
                                <span className={'cb-rec-icon-wrapper'}>
                                    <ThreeDots>
                                        {eventName.split(' - ')[0]}
                                    </ThreeDots>
                                    <ThreeDots>
                                        {eventName.split(' - ')[1]}
                                    </ThreeDots>
                                </span>
                            </Text>
                        </div>
                        {!isEventPage && (
                            <div className={'cb-rec-item-content__top-date'}>
                                <Text
                                    width={'100%'}
                                    size={'10'}
                                    lh={'10'}
                                    margin={'8px 0 0 '}
                                    padding={'0'}
                                    color={'#1E1E1E'}
                                    capitalize
                                    align={'right'}
                                >
                                    {formatDate(kickoff, 'ddd, DD. MMM')}{' '}
                                </Text>
                                <Text
                                    bold
                                    size={'13'}
                                    lh={'20'}
                                    color={'#1E1E1E'}
                                    margin={'12px 0 0'}
                                    padding={'0'}
                                    align={'right'}
                                >
                                    {formatDate(kickoff, 'HH:mm')}
                                </Text>
                            </div>
                        )}
                    </Wrapper>
                )}

                {betRecommendation.items.length > 0
                    ? getEventsList(betRecommendation.items)
                    : null}
            </Wrapper>
            <Wrapper
                padding={'0'}
                margin={'0'}
                className={`button-wrapper ${
                    isEventPage && !detectMobile() ? 'event-page' : ''
                }`}
                boxSizing={'border-box'}
            >
                {isOddsFetched ? (
                    <OddsButton
                        width={isEventPage ? '100%' : 'calc(100% - 73px)'}
                        margin={'0'}
                        padding={'11px 15px'}
                        radius={'4px'}
                        disabled={
                            betRecommendation?.totalOdds === 1 ||
                            betRecommendation?.totalOdds === null
                        }
                        oddsYellow
                        active={isActive()}
                        onClick={() => handleClick()}
                    >
                        {betRecommendation?.totalOdds > 1
                            ? betRecommendation?.totalOdds.toFixed(2)
                            : '-'}
                    </OddsButton>
                ) : (
                    <Wrapper
                        height={'40px'}
                        width={
                            isEventPage
                                ? detectMobile()
                                    ? '100%'
                                    : '123px'
                                : '157px'
                        }
                        padding={'0'}
                        display={'inline-block'}
                        margin={'0'}
                        boxSizing={'border-box'}
                        position={'relative'}
                        overflow={'hidden'}
                    >
                        <SkeletonButton
                            width={
                                isEventPage
                                    ? detectMobile()
                                        ? '100%'
                                        : '123px'
                                    : '157px'
                            }
                            margin={'0'}
                        />
                        <SkeletonAnimation />
                    </Wrapper>
                )}
            </Wrapper>
        </Wrapper>
    );
};

const mapStateToProps = (state) => {
    return { betslip: state.betslip };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addCustomBetRecommendation: bindActionCreators(
            AddCustomBetRecommendation,
            dispatch
        ),
        showModal: bindActionCreators(ShowModal, dispatch),
        clearAllCustomBetMarkets: bindActionCreators(
            ClearAllCustomBetMarkets,
            dispatch
        ),
        clearAllMarkets: bindActionCreators(ClearAllMarkets, dispatch),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomBetRecommendationItem);
